/*
  - First page which is shown when user isn't logged in
  - Commented by Sarthak on Feb 12, 2024

*/
import { Component, OnInit } from "@angular/core";
import { AuthenticationServiceService } from "../authentication-service.service";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { ChangeUsersService } from "../services/change-users.service";
import { BaseUrlConstantsService } from "../services/base-url-constants.service";
import { BackendApiService } from "../services/backend-api.service";
@Component({
  selector: "app-first-enertics",
  templateUrl: "./first-enertics.component.html",
  styleUrls: ["./first-enertics.component.scss"],
})
export class FirstEnerticsComponent implements OnInit {
  public DSPkey = BaseUrlConstantsService.DSP_KEY;
  public Cgkey = BaseUrlConstantsService.CG_KEY;
  public siteMaintenanceApi = BaseUrlConstantsService.siteMaintenanceApi;
  public maintenanceLogList: any = [];
  public underMaintenance:any=false
  public endDateDay="";
  public endDateHr="";
  /* 
    - Checks for localStorage for loginStatus if found then retrieves value of role 
    - Depending upon role redirects to https://dev.enertics.ca/#/admin-dashborad or device-reports or manager-client-list 
    - Role can be ADIM, CLIENT, USER, ACCOUNT_MANAGER
    - if loginStatus is not found we see the first-enertics.html page
    - Commented by Sarthak on Feb 12, 2024
  */
  constructor(
    private authenticationService: AuthenticationServiceService,
    public changeUserDashboard: ChangeUsersService,
    private router: Router,
    private location: Location,
    private service: BackendApiService
  ) {
    if (localStorage.getItem("loginStatus") === "yes") {
      switch (localStorage.getItem("role")) {
        case "ADMIN":
          this.changeUserDashboard.login("Log In");
          this.router.navigate(["/admin-dashboard"]);
          break;
        case "CLIENT":
          this.changeUserDashboard.login("Log In");
          this.router.navigate(["/device-reports"]);
          break;
        case "USER":
          this.changeUserDashboard.login("Log In");
          this.router.navigate(["/device-reports"]);
          break;
        case "ACCOUNT_MANAGER":
          this.changeUserDashboard.login("Log In");
          this.router.navigate(["/manager-client-list"]);
          break;
        case "OEM":
          this.changeUserDashboard.login("Log In");
          this.router.navigate(["/OEM-Client"]);
          break;
      }
    } else {
      this.changeUserDashboard.logout();
    }
  }

  ngOnInit() {
    // localStorage.setItem("loginStatus", "no");
    this.getMaintenanceList();
  }
  getMaintenanceList() {
    this.service
      .getData("https://devapi.enertics.ca/maintenance/maintenance/latest")
      .then((res) => {
        let response = JSON.parse(JSON.stringify(res)).data;
        console.log(response, "res");
        if (response.body.length > 0) {
          this.maintenanceLogList = response.body[0];
          if (
            new Date() >=
              new Date(this.maintenanceLogList.start_date.slice(0, 23)) &&
            new Date() < new Date(this.maintenanceLogList.end_date.slice(0, 23))
          ) {
            this.underMaintenance = true;
            this.endDateDay = this.maintenanceLogList.end_date
              .slice(0, 16)
              .split("T")[0];
            this.endDateHr = this.maintenanceLogList.end_date
              .slice(0, 16)
              .split("T")[1];
          }
        }
      });
  }

  goToLogin() {
    this.router.navigate(["login"]);
  }
}
